import * as dataStore from './DataStore';
import SimilarSeries from '../models/SimilarSeries';

export function getSimilarSeries() {
    const similarSeriesData = dataStore.getJsonData().FeatureContent.SimilarSeries;
    let retval = [];
    if (similarSeriesData) {
        const similarSeries = similarSeriesData.series;
        if (similarSeries && similarSeries.length > 0) {
            retval = similarSeries.map((series) => {
                return new SimilarSeries(series);
            });
        }
    }
    return retval;
}


// WEBPACK FOOTER //
// ./src/data/SimilarSeriesSelectors.js